import React from 'react';
import { Hero } from './Hero';
import { Features } from './Features';
import { Pricing } from './Pricing';
import Testimonials from './Testimonials';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';

export function Home() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { t } = useLanguage();

  const handleStartFreeTrial = () => {
    if (!isAuthenticated) {
      sessionStorage.setItem('redirectAfterLogin', '/dashboard');
      navigate('/login');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <main className="bg-gray-50">
      <Hero />
      <Features />
      <Pricing />
      <Testimonials />
      <div className="bg-gradient-to-br from-[#0D3C4C] to-[#1A5F7A] py-16">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              {t.cta.title}
            </h1>
            <p className="text-xl text-gray-200 mb-8">
              {t.cta.subtitle}
            </p>
            <button
              onClick={handleStartFreeTrial}
              className="bg-white text-[#0D3C4C] px-8 py-4 rounded-lg font-semibold text-lg hover:bg-opacity-90 transition-all duration-200 shadow-lg"
            >
              {t.cta.button}
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}
